import { render, staticRenderFns } from "./solution-new.vue?vue&type=template&id=64f93e2a&scoped=true&"
import script from "./solution-new.vue?vue&type=script&lang=js&"
export * from "./solution-new.vue?vue&type=script&lang=js&"
import style0 from "./solution-new.vue?vue&type=style&index=0&id=64f93e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f93e2a",
  null
  
)

export default component.exports